import styled from "@emotion/styled"
import TextsWrapper from "components/Texts/TextsWrapper"

const TextFourWrapper = styled(TextsWrapper)``

export default TextFourWrapper
